<template>
    <ion-page class="ion-page" id="main">
        <ion-content fullscreen style="padding-left: 5px; padding-right: 5px;">
            <flash-messages/>

<!--            <div v-if="$store.getters.authed && $store.getters.user.covid_agreement_signed_at === null" style="padding: 20px;">-->
<!--                {{ $t('ncrypt.covid_triage.sign_agreement_to_access') }}-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <ion-button @click="$router.push({name: 'covid-agreement-form'})">-->
<!--                    {{ $t('ncrypt.covid_triage.visit_agreement_form_button_text') }}-->
<!--                </ion-button>-->
<!--            </div>-->

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner/>
            </div>

            <ion-card v-else-if="questions.length"
                      id="triage-form"
                      class="floating">
                <ion-card-header style="padding-bottom: 6px;">
                    <ion-card-title>
                        {{ $t('ncrypt.covid_triage_form.title') }}
                    </ion-card-title>

                    <ion-card-subtitle>
                        <img
                            :src="`${ $store.getters.webservice_url }/company-logo-from-token/${ $route.params.token }`"
                            @error="$event.target.src = `${ $store.getters.webservice_url }/storage/logo.png`"
                            style="height: 60px; width: auto; margin: 0 auto;" alt=""/>

                        <ion-select
                            style="position: absolute; top: 0; right: 0; padding: 0;"
                            :value="language"
                            @ionChange="localeChange($event.detail.value)"
                            interface="popover"
                            autocomplete="off">
                            <ion-select-option value="nl">NL</ion-select-option>
                            <ion-select-option value="en">EN</ion-select-option>
                        </ion-select>
                    </ion-card-subtitle>
                </ion-card-header>

                <ion-card-content class="ion-no-padding" style="display: flex; flex-direction: column;">
                    <ion-content>
                        <ion-list lines="none" style="padding-bottom: 30px;">
                            <ion-item v-for="question in questions"
                                      :key="question.key"
                                      v-show="showQuestion(question)">
                                <div class="question-wrapper"
                                     :class="{answered: question.submittedAnswer !== null}">
                                    <div class="question">
                                        <span class="text"
                                              v-dompurify-html='question.question[language].replace(/\\n/g, "<br />")'/>
                                    </div>

                                    <div v-if="question.submittedAnswer !== null"
                                         class="answer">
                                        <span class="text"
                                              v-if="question.submittedAnswer === true"
                                              v-text="question.answer_true[language]"/>

                                        <span class="text"
                                              v-else-if="question.submittedAnswer === false"
                                              v-text="question.answer_false[language]"/>
                                    </div>
                                </div>
                            </ion-item>

                            <ion-item v-if="finished">
                                <div class="question-wrapper">
                                    <div class="question">
                                        <span class="text" style="display: flex;">
                                            <span v-if="hasPositiveAnswer">
                                                {{ $t('ncrypt.covid_triage_form.completed_message_with_yes_answer') }}
                                            </span>

                                            <span v-else>
                                                {{
                                                    $t('ncrypt.covid_triage_form.completed_message_without_yes_answer')
                                                }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </ion-item>
                        </ion-list>
                    </ion-content>

                    <footer style="flex-grow: 0; flex-shrink: 0; align-self: flex-end;">
                        <ion-button v-if="activeQuestion" @click="submitAnswer(true)" :disabled="submittingAnswer">
                            {{ activeQuestion.answer_true[language] }}
                        </ion-button>

                        <ion-button v-if="activeQuestion" @click="submitAnswer(false)" :disabled="submittingAnswer">
                            {{ activeQuestion.answer_false[language] }}
                        </ion-button>

                        <ion-button v-if="finished && !hasPositiveAnswer"
                                    @click="$router.push({name: 'covid-passport'})">
                            {{ $t('ncrypt.covid_triage_form.open_passport') }}
                        </ion-button>
                    </footer>
                </ion-card-content>
            </ion-card>

            <div v-else style="padding: 30px;">
                <br/>
                {{ $t('ncrypt.covid_triage_form.error_opening_triage_checklist') }}
                <br/>
                <br/>
                <br/>
                <ion-button @click="$router.push({name: 'covid-triage'})">
                    {{ $t('ncrypt.covid_triage_form.start_new_checklist') }}
                </ion-button>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import {EventBus} from "@/event-bus";
    import {ApiError} from "@/errors/ApiError";

    export default {
        components: {
            FlashMessages,
        },
        name: "CovidTriageForm",
        data() {
            return {
                language: 'nl',
                loading: true,
                submittingAnswer: false,
                activeQuestionKey: null,
                questions: [],
            }
        },
        computed: {
            activeQuestion() {
                return this.unansweredQuestions.first();
            },
            unansweredQuestions() {
                return this.questions.filter(question => question.submittedAnswer === null);
            },
            finished() {
                return this.questions.length && !this.unansweredQuestions.length;
            },
            hasPositiveAnswer() {
                return this.questions.some(question => question.submittedAnswer === true);
            },
        },
        methods: {
            localeChange(locale) {
                EventBus.$emit('localeChange', locale);
                this.language = locale;
            },
            showQuestion(question) {
                if (this.activeQuestion && this.activeQuestion.key === question.key) {
                    return true;
                }

                return question.submittedAnswer !== null;
            },
            submitAnswer(answer) {
                if (!this.activeQuestion) {
                    return;
                }

                this.submittingAnswer = true;

                this.$http.post(`covid-triage/form/questions/${this.$route.params.token}/store-answer`, {
                    key: this.activeQuestion.key,
                    answer,
                })
                    .then((response) => {
                        if (response.status >= 300) {
                            new ApiError(response, true);
                            return;
                        }

                        this.activeQuestion.submittedAnswer = answer;

                        setTimeout(() => {
                            document.querySelector('#triage-form ion-content').scrollToBottom(500);
                        }, 50);
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.submittingAnswer = false);
            },
            loadQuestions() {
                this.loading = true;

                this.$http.get(`covid-triage/form/questions/${this.$route.params.token}`)
                    .then(async ({data}) => {
                        if (!data || !Array.isArray(data.data)) {
                            new ApiError(data);
                            return;
                        }

                        this.questions = data.data.map(question => {
                            question.submittedAnswer = null;

                            return question;
                        });
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.loading = false);
            },
        },
        mounted() {
            // if (!this.$store.getters.authed || this.$store.getters.user.covid_agreement_signed_at !== null) {
                this.loadQuestions();
            // }
        },
    }
</script>

<style lang="scss">
    #triage-form {
        text-align: center;
        margin-left: auto;
        margin-right: auto;

        .mobile-or-small & {
            margin: 10px;
        }

        .question-wrapper {
            width: 100%;
            float: left;

            &.answered {
                .question {
                    opacity: 0.75;
                }
            }
        }

        ion-card-content {
            height: calc(100vh - 300px);
            max-height: 550px;

            .mobile-or-small & {
                height: calc(100vh - 245px);
                max-height: 100vh;
            }
        }

        footer {
            width: 100%;
            background: #eee;
            padding: 8px;

            ion-button {
                margin-left: 5px;
                margin-right: 5px;
            }
        }

        .question, .answer {
            width: 100%;
            float: left;
            margin: 2px 0;

            .text {
                color: white;
                padding: 8px 15px;
                border-radius: 12px;
                white-space: pre-line;
            }
        }

        .question {
            padding-right: 7px;

            .text {
                text-align: left;
                float: left;
                background: var(--ion-color-primary, #3880ff);
            }
        }

        .answer {
            margin-bottom: 20px;
            padding-left: 7px;

            .text {
                text-align: right;
                float: right;
                background: #72aba3;
            }
        }
    }
</style>
